import React from "react";
import { useFirebase } from "../context/ApiContext";
import { isMetaInAppBrowser } from "../utils/inAppBrowser";
import SplashScreen from "./SplashScreen";

/**
 * Muestra la splash en toda la app mientras useFirebase está en initialLoading
 * (cargando el usuario). Debe renderizarse dentro de ApiProvider.
 * En Instagram/Facebook in-app no se muestra: el blur a pantalla completa
 * deja la WebView de Samsung en blanco.
 */
export default function GlobalSplashScreen() {
	const { initialLoading } = useFirebase();
	if (isMetaInAppBrowser()) return null;
	return <SplashScreen isLoading={initialLoading} />;
}
